import { useContext } from "react";
import { MdArrowOutward } from "react-icons/md";
import { AppContext } from "../App";
import { MotionGroup, MotionItem, MotionReveal, MotionText } from "../components/MotionReveal";
import { getServiceTone, homeFeaturedServices, ServiceBadgeIcon } from "./ServicesContent";

export default function HomeServicesContent() {
  const appContext = useContext(AppContext);

  function goToService(slug) {
    appContext.navTo({ item: "services", subItem: slug });
  }

  return (
    <section className="tgm-section tgm-home-services">
      <div className="container">
        <MotionGroup className="tgm-editorial-head" stagger={0.08}>
          <div>
            <MotionReveal
              as="p"
              className="tgm-editorial-kicker"
              variant="soft"
            >
              Our Service
            </MotionReveal>
            <MotionText as="h2" text="A Comprehensive Set Of Services" />
          </div>
          <MotionReveal
            as="button"
            type="button"
            className="tgm-view-more-btn"
            onClick={() => appContext.navTo({ item: "services" })}
            variant="right"
            whileHover={{ x: 4 }}
            whileTap={{ scale: 0.96 }}
          >
            View more <MdArrowOutward />
          </MotionReveal>
        </MotionGroup>

        <MotionGroup className="tgm-service-badge-grid" stagger={0.1}>
          {homeFeaturedServices.map((service, index) => (
            <MotionItem
              as="button"
              variant="card"
              type="button"
              className="tgm-service-badge"
              data-tone={getServiceTone(index)}
              style={{ "--badge-image": `url(${service.heroImage})` }}
              key={service.slug}
              onClick={() => goToService(service.slug)}
              whileHover={{ y: -9 }}
              whileTap={{ scale: 0.985 }}
            >
              <ServiceBadgeIcon type={service.icon} />
              <MotionText
                as="strong"
                text={service.title}
                stagger={0.035}
                amount={0.35}
              />
              <MotionReveal
                as="span"
                className="tgm-service-badge-summary"
                variant="soft"
                delay={0.08}
              >
                {service.summary}
              </MotionReveal>
              <MotionReveal
                as="span"
                className="tgm-service-badge-link"
                variant="soft"
                delay={0.14}
              >
                Learn More <MdArrowOutward />
              </MotionReveal>
            </MotionItem>
          ))}
        </MotionGroup>
      </div>
    </section>
  );
}
